/**
 * Modules enabled on production deploys.
 *
 * Edit this list before deploying. Any catalog module not listed here is shown as
 * "Coming soon" in production builds (cards, study routes, profile stats).
 *
 * Local `npm start` enables every module unless REACT_APP_LIVE_MODULES is set in .env
 * (use that to preview production gating locally).
 */
export const LIVE_MODULE_IDS = [
  'intro-module',
  'workplace-module',
  'educator-module',
  'community-module',
  'parent-module',
];
